import { createSelector } from "reselect"
import { get, chain, pickBy } from "lodash"
import moment from "moment"
import { getAllItems, getOrderedCategoryItems } from "./items"
import { getFilteredRisk } from "./risk"
import { COLORS, ANALYZE_FACTORS_TAKE } from "helpers/analyzeConstants"
import { computeDisplayCategories, computeNonZerosKeys } from "helpers/analyze"

const getFavoriteFactors = (_, props) => props.favoriteFactors

export function computeData(items, risk) {
  return chain(risk)
    .map((datum, index) => {
      const { date } = datum

      const result = chain(items)
        .map(item => ([
          item.id,
          item.fn
            ? item.fn(datum)
            : get(datum, item.field, 0),
        ]))
        .filter(([, value]) => !Number.isNaN(value))
        .fromPairs()
        .value()

      result.date = moment(date)
      result.index = index

      return result
    })
    .filter(datum => datum)
    .value()
}

export const getData = createSelector(
  [getAllItems, getFilteredRisk],
  computeData,
)

const getNonZerosKeys = createSelector(
  [getData, getFavoriteFactors],
  (data, favoriteFactors) => computeNonZerosKeys(data, favoriteFactors, (value) => value !== 0),
)

export const getFilteredData = createSelector(
  [getData, getNonZerosKeys],
  (data, keys) => data.map(item => pickBy(item, (item, key) => keys[key])),
)

export const getCategoryItemsSubset = createSelector(
  [getOrderedCategoryItems, getNonZerosKeys],
  (items, keys) =>
    chain(items)
      .filter(item => keys[item.id])
      .take(ANALYZE_FACTORS_TAKE + 1) // 1 category total item + X items
      .map((item, index) => ({
        ...item,
        color: item.color || COLORS[index - 1], // Ignore to the total item color
      }))
      .thru(subset => {
        // If only 1 item, force its display by putting disabled at `false`
        if (subset.length === 1) {
          return [{ ...subset[0], disabled: false }]
        }
        return subset
      })
      .value(),
)

export const getDisplayCategories = createSelector(
  [getAllItems, getNonZerosKeys],
  computeDisplayCategories,
)
